import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import 'formBuilder'; // Make sure formBuilder and formRender are properly imported
import 'formBuilder/dist/form-render.min.js';
const FormRenderer = () => {
  const formRenderRef = useRef(null);
  const [formData, setFormData] = useState('');

  useEffect(() => {
    // Simulate an API call to fetch the formData in JSON format
    setFormData(
   [{"type":"header","subtype":"h1","label":"formBuilder"},{"type":"paragraph","subtype":"p","label":"This is a demonstration of formBuilder running."},{"type":"text","label":"Text Field","className":"form-control","name":"text-1732453958284","subtype":"text"},{"type":"number","label":"Number","className":"form-control","name":"number-1732453963334"}]    )
  }, []);

  useEffect(() => {
    if (formData && formRenderRef.current) {
      $(formRenderRef.current).formRender({
        dataType: 'json',
        formData: formData
      });
    }
  }, [formData]);

  const handleSubmit = () => {
    const inputs = $(formRenderRef.current).find(':input');
    const filledData = {};

    inputs.each(function() {
      const inputType = $(this).attr('type');
      const name = $(this).attr('name');

      if (!name) return;

      // Capture different input types
      switch (inputType) {
        case 'checkbox':
          if (!filledData[name]) filledData[name] = [];
          if ($(this).is(':checked')) filledData[name].push($(this).val());
          break;

        case 'radio':
          if ($(this).is(':checked')) filledData[name] = $(this).val();
          break;

        case 'file':
          filledData[name] = $(this)[0].files; // FileList object for file input
          break;

        default:
          filledData[name] = $(this).val();
      }
    });

    // For 'select' elements with multiple values
    $(formRenderRef.current).find('select').each(function() {
      const name = $(this).attr('name');
      if (!name) return;

      const isMultiple = $(this).attr('multiple');
      if (isMultiple) {
        filledData[name] = $(this).val(); // Returns an array of selected values
      } else {
        filledData[name] = $(this).val();
      }
    });

    console.log('Form data submitted:', filledData);
    // Now `filledData` contains all user-filled data, ready for submission or further processing
  };

  return <>
  <div className="fb-render" ref={formRenderRef}></div>
  <button className='btn btn-primary' onClick={handleSubmit}>Submit</button>
  </>;
};

export default FormRenderer;
